module.exports = __webpack_public_path__ + "img/analytics.df62c766.svg";